import { Component } from 'react';

class IteamFooterExerciseNavBar extends Component {

    render() {
        let audiovideocomponent = '';
        if (this.props.exerciseAudioDM !== undefined && this.props.exerciseAudioDM !== null) {
            audiovideocomponent = (<audio controls src={this.props.exerciseAudioDM.src}></audio>);
        }

        if (this.props.exerciseVideoDM !== undefined && this.props.exerciseVideoDM !== null) {
            audiovideocomponent = (<video controls src={this.props.exerciseVideoDM.src}></video>);
        }

        return (<div className='exerciseNavigationBar'>
            <div className='iTeamBtnReturnToPageContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.props.returnToPageHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M185.81,164.72H96.53V138.34h45A14.21,14.21,0,0,0,153.82,117L90.21,7.11a14.25,14.25,0,0,0-24.67,0L1.93,117a14.22,14.22,0,0,0,12.34,21.32H61.16v47.37A14.48,14.48,0,0,0,75.49,200H185.81A14.22,14.22,0,0,0,200,185.84v-7A14.22,14.22,0,0,0,185.81,164.72Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnNavPrevExerciseContainer iTeamFooterBtnContainer icon-forward'>
                <button className='btnFooter' onClick={this.props.navigateToPrevExerciseHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M0,99.74A27.56,27.56,0,0,0,19.19,126.3l140.92,70.79a27.67,27.67,0,0,0,24.67-49.54l-95-47.7,95-47.48A27.66,27.66,0,0,0,160.06,2.88L19.72,73A27.55,27.55,0,0,0,0,99.74Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnNavNextExerciseContainer iTeamFooterBtnContainer icon-backward'>
                <button className='btnFooter' onClick={this.props.navigateToNextExerciseHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M200,100.26A27.56,27.56,0,0,0,180.81,73.7L39.89,2.91A27.67,27.67,0,0,0,15.22,52.45l95,47.7-95,47.48a27.66,27.66,0,0,0,24.74,49.49L180.28,127A27.55,27.55,0,0,0,200,100.26Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnExerciseCheckContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.props.checkAnswersHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M187.89,5.93l-3.35-2.08a25.7,25.7,0,0,0-35.34,8.29L78.27,126.69,45,93.35a20.38,20.38,0,0,0-28.78,0L5.93,103.69a20.49,20.49,0,0,0,0,28.84l53.85,54a25.45,25.45,0,0,0,6,6.07l1.48,1.49a20.38,20.38,0,0,0,20.38,5.05,25.64,25.64,0,0,0,18.14-11.87L196.16,41.35A25.83,25.83,0,0,0,187.89,5.93Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnExerciseShowAnswerContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.props.showAnswerOneByOneHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M197.77,93.65C184.18,78,145.54,38.54,100,38.54S15.82,78,2.23,93.65a10.16,10.16,0,0,0,0,12.7c13.59,15.7,52.23,55.11,97.77,55.11s84.18-39.41,97.77-55.11A10.16,10.16,0,0,0,197.77,93.65Zm-97.67,49.9A43.55,43.55,0,1,1,143.64,100,43.55,43.55,0,0,1,100.1,143.55Z"/><path d="M100.1,72.89A27.11,27.11,0,1,0,127.21,100,27.14,27.14,0,0,0,100.1,72.89ZM108.32,100a8.22,8.22,0,1,1,8.21-8.21A8.22,8.22,0,0,1,108.32,100Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnExerciseRestartContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.props.restartExerciseHandler}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 200"><path d="M181.25,158.13,225,100H200a100.24,100.24,0,1,0-31.34,72.57L145.9,142.33A62.44,62.44,0,1,1,162.5,100h-25Z"/></svg>
                </button>
            </div>
            <div className='iTeamAudioVideoContainer'>
                {audiovideocomponent}
            </div>
        </div>);
    }
}

export default IteamFooterExerciseNavBar;